import { render, staticRenderFns } from "./icon-arrow.vue?vue&type=template&id=7d494c4d&scoped=true&"
import script from "./icon-arrow.vue?vue&type=script&lang=js&"
export * from "./icon-arrow.vue?vue&type=script&lang=js&"
import style0 from "./icon-arrow.vue?vue&type=style&index=0&id=7d494c4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d494c4d",
  null
  
)

export default component.exports